import { CONTACT_EMAIL } from '../site/contact';
import { fetchInviteByEmail } from '../admin/inviteRemote';
import { hasPortalInvite, hasPortalInviteForEmail } from '../admin/inviteStore';
import { isAdminEmail, isFirebaseConfigured } from './config';

export const ADMIN_ON_OWNER_PAGE_MESSAGE =
    'This account is for admin access. Please use the admin sign-in page.';

export const NO_PORTAL_LOGIN_MESSAGE = `We don't have a portal login for this email yet. If you applied, we'll email you when it's ready. If you were expecting access, contact us at ${CONTACT_EMAIL}.`;

export const getOwnerSignInBlockReason = async (
    email: string | null | undefined
): Promise<string | null> => {
    if (isAdminEmail(email)) {
        return ADMIN_ON_OWNER_PAGE_MESSAGE;
    }

    if (!email) {
        return NO_PORTAL_LOGIN_MESSAGE;
    }

    // Only read the invite after this person is signed in as that email.
    // Anonymous Firestore reads are denied so phone/notes stay private.
    if (isFirebaseConfigured()) {
        try {
            const invite = await fetchInviteByEmail(email);
            if (!invite || !hasPortalInvite(invite)) {
                return NO_PORTAL_LOGIN_MESSAGE;
            }
            return null;
        } catch {
            return 'We could not check your invitation. Please try again.';
        }
    }

    if (!hasPortalInviteForEmail(email)) {
        return NO_PORTAL_LOGIN_MESSAGE;
    }

    return null;
};
